








































































































































































































import { Component, Watch,  Vue } from 'vue-property-decorator';
import { EntityForm, asFormData } from '@/base';
import { CreditJson, CreditState } from '../json';
import store, { Actions } from '../store';
import { ContactForm } from '@/modules/contact';
import PositionList from '../components/PositionList.vue';
import { getDescription as getContactDescription, ContactJson } from '@/modules/contact';
import { store as mainStore, Getters } from '@/store';
import { UserType, UserPermission } from '../../../user';
import { VatConfigurationJson } from '@/modules/vatconfiguration';
import { store as vatStore, Actions as vatActions } from '@/modules/vatconfiguration/store';

@Component<Form>({
  beforeRouteEnter(to, from, next): void {
    next(vm => vm.handleBeforeRouteEnter(to, from, next));
  },
  beforeRouteLeave(to, from, next): void {
    this.handleBeforeRouteLeave(to, from, next);
  },
  filters: {
    contact: (item: ContactJson | null, fallbackToId?: boolean): string => {
      const desc = item ? getContactDescription(item) : null;
      if (desc) {
        return `(${desc})`;
      }
      return '';
    },
  },
  components: {
    ContactForm,
    PositionList,
  },
})
export default class Form extends EntityForm<CreditJson, typeof store> {
  protected hasWritePermission(): boolean {
    return this.hasPermission(UserPermission.ACCOUNTING_WRITE);
  }

  @Watch('activeItem.creditDate')
  private getVatConfigurations(creditDate: any | null): void {
    if (creditDate) {
      vatStore[vatActions.READ_VAT_CONFIGURATIONS_VALID_FROM](creditDate).then(vatConfig => {
        this.vatConfigurations = vatConfig;
      });
    }
  }

  private vatConfigurations: VatConfigurationJson[] = [];

  get totalNet(): number {
    let totalNet = 0;
    if (this.activeItem) {
      this.activeItem.creditPositions.forEach(pos => totalNet += pos.totalPriceNet || 0);
    }
    return totalNet;
  }

  private totalGross: number = 0;

  // Helper to watch two properties with one handler -> updateTotalGross()
  get creditPositionsAndVatConfigurations(): any {
    return `${(this.activeItem && this.activeItem.creditPositions) ? JSON.stringify(this.activeItem.creditPositions) : ''}|${JSON.stringify(this.vatConfigurations)}`;
  }

  @Watch('creditPositionsAndVatConfigurations', {deep: true})
  private updateTotalGross(creditPositionsAndVatConfigurations: string): void {
    const [creditPositions, vatConfigurations] = creditPositionsAndVatConfigurations.split('|').map((el: string) => JSON.parse(el));
    let totalGross = 0;

    if (creditPositions && vatConfigurations.length) {
      creditPositions.forEach((pos: any) => {
        if (pos.totalPriceNet) {
          const vatConfig = vatConfigurations.find((vatConf: any) => vatConf.vat === pos.vat);
          totalGross += pos.totalPriceNet * (1 + (vatConfig ? vatConfig.vatRate : 0));
        }
        });
    }
    this.totalGross = totalGross;
  }

  get vat(): number {
    return this.totalGross - this.totalNet;
  }

  protected readonly store = store;

  protected readonly closeRoute = {
    name: 'credit',
  };

  private downloadCreditPdf(): void {
    const activeItem = this.activeItem;
    if (activeItem && activeItem.fileNameCreditPDF) {
      store[Actions.DOWNLOAD_CREDIT_PDF](activeItem.id);
    }
  }

  private createPDF(): void {
    if (this.activeItem) {
      store[Actions.CREATE_CREDIT_PDF](this.activeItem);
    }
  }

  protected isAllowForAdminsAndOfficeWorkers(): boolean {
    const currentUserType = mainStore[Getters.CURRENT_USER_LOGIN]!.userType;
    return currentUserType === UserType.OFFICE_WORKER || currentUserType === UserType.ADMIN;
  }

  protected isFormDisabled(): boolean {
    return !this.hasWritePermission() || !this.activeItem || !(this.activeItem.creditState === CreditState.CREATED) || !this.isAllowForAdminsAndOfficeWorkers();
  }

  protected isDirty(): boolean {
      const activeItem = this.activeItem;
      if (activeItem && (this.isNew(activeItem) || this.hasUnsavedChanges(activeItem))) {
        return true;
      }
      return false;
  }
}
